module.exports = __webpack_public_path__ + "img/backBtn.d59127a7.svg";